export default __webpack_public_path__ + "static/media/AElement Fusion.ed05512b.jpg";